export default {
  inputPlaceholder: 'dd.mm.yyyy',
};
